<ngx-qrcode
  [elementType]="type"
  [value]="value"
  cssClass="aclass"
  errorCorrectionLevel="L"
  [correctionLevel]="'H'"
>
</ngx-qrcode>
